// extracted by mini-css-extract-plugin
module.exports = {"top-section":"_39C3D","topSection":"_39C3D","app-icon":"_19Trb","appIcon":"_19Trb"};